<template>
        <h6 data-aos="zoom-out-up"
            data-aos-easing="linear"
            data-aos-duration="1000" className='text-center mt-10 font-bold md:text-3xl xl:text-4xl mx-2'>Hey Mr.X! Please stay with us for latest update</h6>
</template>

<script>
    export default {
        name: "CheckoutA",
    }
</script>

<style scoped>

</style>